import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout';
import OrderCard from '../../components/orderCard';
import { withRouter } from 'react-router-dom';
import { withAlert } from 'react-alert';
import { ENUM_LAYOUT_STATE } from '../../helpers/enums';
import { searchOrders } from '../../helpers/functions';
import { OrderService } from '../../services/order.service';
import { STORAGE_KEYS } from '../../helpers/constants';

const Scheduled = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN);

  const loadOrders = async () => {
    try {
      const res = await OrderService.getScheduledOrders({
        cokitchen_id: cokitchenId
      });
      setOrders(
        res.data.results.sort(
          (a, b) =>
            new Date(a.scheduled_delivery_datetime).getTime() -
            new Date(b.scheduled_delivery_datetime).getTime()
        )
      );
    } catch (error) {
      alert?.show('An error occured', { type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(async () => {
    setLoading(true);
    loadOrders();
  }, []);

  useEffect(() => {
    const filtered = searchOrders({ searchValue, orders });
    setFilteredOrders(filtered);
  }, [orders, searchValue]);

  const getLayoutState = () => {
    if (filteredOrders.length === 0 && searchValue) return ENUM_LAYOUT_STATE.EMPTY_SEARCH;
    if (loading) return ENUM_LAYOUT_STATE.LOADING;
    return ENUM_LAYOUT_STATE.PAGE;
  };
  return (
    <Layout
      pendingOrders={0}
      trackingOrders={orders?.length}
      searchValue={searchValue}
      searchChange={(e) => setSearchValue(e.target.value?.toUpperCase())}
      layoutState={getLayoutState()}>
      {filteredOrders.map((item, i) => (
        <OrderCard
          key={item.id + item.updated_at}
          order={item}
          onActionClick={loadOrders}
          hideCardButton
        />
      ))}
      {orders.length === 0 && (
        <div className='text-[3rem] text-white text-center flex grow items-center justify-center'>
          There are no scheduled orders
        </div>
      )}
    </Layout>
  );
};
export default withRouter(withAlert()(Scheduled));
